import { ArtifactType } from '@app/client/common/structs/nft/artifacts';
import { generateDataItem } from '@app/helpers';
import { type ArtifactTypeDisplay, type UserArtifactOwnedItems } from '@app/store/types/artifacts';

export function artifactDisplayMetadata(state) {
    const { artifactMetadata, userArtifacts } = state.artifacts;

    const userRoseItems = userArtifacts?.CelestialRose;
    const userRoseArray = userRoseItems ? generateDataItem().ownedIds(userRoseItems) : null;

    const firstRoseItem =
        artifactMetadata
            ?.sort((a, b) => parseInt(a.metadata.token_id) - parseInt(b.metadata.token_id))
            .find((item) => userRoseArray?.includes(item.main_id)) ||
        artifactMetadata?.find((item) => item.artifact_type === ArtifactType.CelestialRose);

    const roseDisplayItem = firstRoseItem && generateDataItem().displayMetadata(firstRoseItem);

    const artifactTypeDisplayItems: ArtifactTypeDisplay = {
        [ArtifactType.CelestialRose]: roseDisplayItem,
    };

    artifactMetadata?.forEach((item) => {
        if (item.artifact_type !== ArtifactType.CelestialRose) {
            return (artifactTypeDisplayItems[item.artifact_type] = generateDataItem().displayMetadata(item));
        }
    });

    return artifactTypeDisplayItems;
}

export function usersOwnedArtifacts(state) {
    const userArtifactBreakdown = state.artifacts.userArtifacts;
    const ownedItems: UserArtifactOwnedItems = {};

    userArtifactBreakdown &&
        Object.keys(userArtifactBreakdown).forEach((type) => {
            const typeBreakdown = userArtifactBreakdown[type];
            const allOwnerAssetIds = generateDataItem().ownedIds(typeBreakdown);
            if (allOwnerAssetIds.length > 0) {
                ownedItems[type] = allOwnerAssetIds as string[];
            }
        });

    return ownedItems;
}

export function usersOwnedArtifactIds(state) {
    const { userArtifacts } = state.artifacts;
    let totalIds: UserArtifactOwnedItems[] = [];
    userArtifacts &&
        Object.keys(userArtifacts).forEach((type) => {
            const breakdown = userArtifacts[type];
            totalIds = totalIds.concat(generateDataItem().ownedIds(breakdown));
        });
    return totalIds;
}

// export function displayMetadataSelector(state) {
//     const { artifactMetadata } = state.artifacts;
//     const displayMetadata: ArtifactTypeDisplay = {};
//     artifactMetadata?.forEach((asset) => {
//         const item = generateDataItem().displayMetadata(asset);
//         displayMetadata[item.artifact_type] = { ...item };
//     });
//     return displayMetadata;
// }
